// src/utils/walletTopupActions.js
// Shared admin actions for cash package (wallet top-up) requests, used by both the
// Customer Details Page's Transactions tab and the global Packages admin tab,
// so both surfaces call one implementation.
import { auth } from './firebase';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

async function getAdminAuthToken() {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('Admin is not authenticated');
  }
  return await user.getIdToken();
}

export async function verifyTopup(transactionId, salonId) {
  const token = await getAdminAuthToken();
  const response = await fetch(`${API_BASE_URL}/api/wallet/verify-topup`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ transactionId, salonId })
  });
  const data = await response.json();
  if (!response.ok || !data.success) {
    throw new Error(data.message || 'Failed to verify cash package top-up');
  }
  return data;
}

export async function rejectTopup(transactionId, salonId, rejectionReason) {
  const token = await getAdminAuthToken();
  const response = await fetch(`${API_BASE_URL}/api/wallet/reject-topup`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ transactionId, salonId, rejectionReason })
  });
  const data = await response.json();
  if (!response.ok || !data.success) {
    throw new Error(data.message || 'Failed to reject cash package top-up');
  }
  return data;
}
